import $ from "jquery";
import MasonryLayout from "masonry-layout";
import ImagesLoaded from "imagesloaded";

var Masonry = {
  init: function () {
    $(".masonry-grid").each(function () {
      var grid = this;
      ImagesLoaded(grid, function (instance) {
        new MasonryLayout(grid, {
          itemSelector: ".masonry-item",
          columnWidth: ".masonry-sizer",
          percentPosition: true,
        });
      });
    });
  },
};

export default Masonry;